import { ArrowRightStartOnRectangleIcon, KeyIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSessionStore } from '@/entities/session/model/sessionStore';
import { ChangePasswordDialog } from '@/features/auth/change-password/ui/ChangePasswordDialog';
import { useLogoutAction } from '@/features/auth/logout/lib/useLogoutAction';
import { Avatar, Button, DropdownMenu, Text } from '@/shared/ui';

/**
 * ユーザーメニュー（グローバルナビゲーション右上）
 *
 * ユーザー情報（名前・メール・最終ログイン日時）の表示とパスワード変更・ログアウト機能を提供する
 */
export const UserMenu = () => {
  const { t } = useTranslation();
  const user = useSessionStore((state) => state.user);
  const logoutAction = useLogoutAction();
  const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);

  return (
    <>
      <DropdownMenu
        triggerClassName="focus:ring-0 focus-visible:ring-0"
        contentClassName="p-2 space-y-2 max-w-[240px]"
        menuItems={[
          {
            key: 'user-info',
            hasBottomSeparator: true,
            item: (
              <div className="max-w-[200px]">
                <Text truncate>{user?.name}</Text>
                <Text variant="description">{user?.email}</Text>
              </div>
            ),
          },
          {
            key: 'login-info',
            hasBottomSeparator: true,
            item: (
              <div>
                <Text variant="description">{t('auth.user-menu.last-login')}</Text>
                <Text variant="description" viewMode="date" format="YYYY/MM/DD HH:mm:ss">
                  {user?.lastLogin}
                </Text>
              </div>
            ),
          },
          {
            key: 'change-password',
            hasBottomSeparator: true,
            item: (
              <div className="flex items-center">
                <KeyIcon className="mr-2 h-4 w-4" />
                {t('auth.user-menu.change-password')}
              </div>
            ),
            onClick: () => {
              setIsChangePasswordOpen(true);
            },
          },
          {
            key: 'logout',
            item: (
              <div className="flex items-center">
                <ArrowRightStartOnRectangleIcon className="mr-2 h-4 w-4" />
                {t('auth.user-menu.logout')}
              </div>
            ),
            onClick: () => {
              logoutAction.mutate();
            },
          },
        ]}
      >
        <Button variant="non-outline" size="icon" aria-label="ユーザーメニュー">
          <Avatar userName={user?.name} className="cursor-pointer" />
        </Button>
      </DropdownMenu>

      <ChangePasswordDialog open={isChangePasswordOpen} onOpenChange={setIsChangePasswordOpen} />
    </>
  );
};
